<template>
  <div class="tab-news-wrapper" v-if="data">
    <div class="title">
      <div class="text">{{ data.name }}</div>
      <div class="line" />
    </div>
    <div class="tab-news-nav" v-if="list.length" :class="[data.relates.length < 5 && 'flexCont' ]">
      <p v-for="(item, index) in data.relates" :key="item.id" :class="[curIndex === index && 'active']" @click="changeChannel(index)">
        <span>{{ item.title }}</span>
      </p>
    </div>
    <div class="tab-news-list-wrapper" v-if="list.length">
      <div class="tab-news-list-inner" v-for="(item, index) in list" v-show="curIndex === index" :key="index">
        <div class="tab-news-list" v-if="item.list && item.list.length">
          <div class="tab-news-item" v-for="item in item.list" @click="goPage(item)" :key="item.id" v-show="item.flag != 1">
            <span>{{ item.itemTitle }}</span>
            <!-- 分区线 -->
            <div class="Underline"></div>
          </div>
          <router-link class="more" :to="{ path: '/channel/' + item.id, query: { lan: lang } }">查看更多</router-link>
        </div>
        <div class="loading" v-if="item.isLoading">
          <img src="../../assets/img/loading.gif" alt="" />
          <p>加载中，请稍后...</p>
        </div>
        <Empty :emptydata="item.emptydata" v-if="item.emptydata" />
      </div>
    </div>
    <Empty :emptydata="{ type: 'nodata' }" v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Filters from '@/utils/filters'

export default {
  name: 'TabNews',
  data () {
    return {
      list: [],
      curIndex: 0
    }
  },
  props: ['homeData', 'data'],
  computed: {
    ...mapState(['lang'])
  },
  created () {
    if (this.data && this.data.relates && this.data.relates.length) {
      this.list = JSON.parse(JSON.stringify(this.data.relates))
      this.changeChannel(0)
    }
  },
  methods: {
    getNews () {
      const newList = JSON.parse(JSON.stringify(this.list))
      this.$Api
        .getChannelList({
          channelId: this.list[this.curIndex].id,
          pageSize: 5,
          queryType: 3
        })
        .then((data) => {
          if (data && data.list && data.list.length) {
            newList[this.curIndex].list = data.list
          } else {
            newList[this.curIndex].emptydata = {
              type: 'nodata'
            }
          }
          newList[this.curIndex].isLoading = false
          this.list = JSON.parse(JSON.stringify(newList))
        })
        .catch(() => {
          newList[this.curIndex].emptydata = {
            type: 'nonetwork'
          }
          newList[this.curIndex].isLoading = false
          this.list = JSON.parse(JSON.stringify(newList))
        })
    },
    changeChannel (index) {
      this.curIndex = index
      const newList = JSON.parse(JSON.stringify(this.list))
      newList[this.curIndex].isLoading = true
      newList[this.curIndex].emptydata = null
      newList[this.curIndex].list = []
      this.list = JSON.parse(JSON.stringify(newList))
      this.getNews()
    },
    goPage (item) {
      const link = Filters.link(item)
      if (this.$Common.isHyperlinks(link)) {
        window.location.href = link
      } else {
        this.$router.push({
          path: link,
          query: {
            lan: this.lang
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-news-wrapper {
  margin: 5.33vw 0 0 0;

  .title {
    margin-bottom: 8.8vw;
  }
  .tab-news-nav {
    display: flex;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    p {
      // width: 24.352vw;
      height: 9.63vw;
      color: #000000;
      font-size: 3.73vw;
      font-weight: bold;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: normal;
      padding: 0 2vw;
      &.active {
        font-size: 4.26vw;
        border-bottom: 1.06vw solid #002fa7;
        color: #002fa7;
      }
      white-space: nowrap; //不换行
      // overflow: hidden; //隐藏
      text-overflow: ellipsis;
      span {
      }
    }
  }
  .tab-news-list {
    .tab-news-item {
      // height: 11.2vw;
      font-size: 3.73vw;
      color: rgba(0, 0, 0, 0.85);
      span {
        color: #000000;
        // line-height: 11.2vw;
        margin: 2vw 0vw;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .Underline {
        margin: 0vw;
      }
    }
    .more {
      height: 8.519vw;
      background-color: #edf3fe;
      display: flex;
      text-decoration: none;
      justify-content: center;
      align-items: center;
      font-size: 3.704vw;
      line-height: normal;
      color: #002fa7;
      margin-top: 6.66vw;
    }
  }
  .empty-wrapper {
    height: auto;
    padding: 10vw 0;
  }
  .loading {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10vw 0;
    img {
      width: 13vw;
    }
    p {
      width: 100%;
      font-size: 3vw;
      color: #000;
      text-align: center;
      line-height: 1.4;
    }
  }
}
.flexCont {
  justify-content: space-around;
}
</style>
